module.exports = __webpack_public_path__ + "static/media/we.13a3f60f.svg";